import { render } from "./learnInfor.vue?vue&type=template&id=2de375c1&scoped=true"
import script from "./learnInfor.vue?vue&type=script&lang=js"
export * from "./learnInfor.vue?vue&type=script&lang=js"

import "./learnInfor.vue?vue&type=style&index=0&id=2de375c1&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2de375c1"]])

export default __exports__